import { ActionTypes } from "./actions.js";
import { getInitialState } from "./state.js";
const initialState = getInitialState();
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.fetch:
            return {
                ...state,
                fetchStatus: "loading",
                paymentCollection: undefined,
                error: undefined
            };
        case ActionTypes.fetchSuccess:
            return {
                ...state,
                fetchStatus: "success",
                paymentCollection: action.payload.paymentCollection,
                error: undefined
            };
        case ActionTypes.fetchError:
            return {
                ...state,
                fetchStatus: "failed",
                paymentCollection: undefined,
                error: action.payload.error
            };
        case ActionTypes.reset:
            return getInitialState();
        default:
            return state;
    }
};
export { reducer, getInitialState };
